import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import './app.less';
import {
  StatusList,
  StatusDetails,
  EnterpriseList,
  RuleObject,
  Rules,
  Props,
  ComponySet,
  UsersSet,
  NoPermisson,
  MbtfList,
  AppBinding,
  SlaList,
  SourceMaterial,
  AppManage,
  SignAndPayment,
  RenderManagement,
  RenderDetails,
} from '@/pages';
import Main from './main';
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { getCookie, goPlatformLogin, setToken, storageClear } from './utils/utils';
import * as api from '@/services/initial';
import { Spin } from 'antd';
import { mainStore, permissionStore } from './store';
import { menus } from '@/config';
import FlexGroup from './pages/flex-group';

let USEID: string | number = '';

const App: React.FC = () => {
  const navigate = useNavigate();
  const [, forceUpdate] = useState({});
  const [, setMainStore] = useRecoilState(mainStore);
  const [, setPermissions] = useRecoilState(permissionStore);

  const fetchUserInfo = async (userId: number) => {
    try {
      return await api.getUserInfo(userId);
    } catch (error) {
      storageClear();
      goPlatformLogin();
    }
    return undefined;
  };

  useEffect(() => {
    // 从cookie or window.name中获取
    const { userId, token, refreshToken } = JSON.parse(getCookie('token') || '{}') as {
      userId: number;
      token: string;
      refreshToken: string;
    };
    if (!userId) {
      storageClear();
      goPlatformLogin();
      return;
    }

    setToken({
      userId,
      auth: {
        token,
        refreshToken,
      },
    });

    USEID = userId;

    fetchUserInfo(userId).then((userInfoRes) => {
      const currentUser: CurrentUser = userInfoRes?.data;
      if (currentUser?.name) {
        localStorage.setItem('userName', currentUser?.name);

        //请求权限
        api.getPermissionAction().then((res: any) => {
          console.log(res, '===res');
          if (res?.success) {
            const details = res?.data?.details || [];
            setPermissions(details);
            const currentPath = menus?.find((m) =>
              window.location.pathname.includes(m?.commonPath || m.path),
            );
            if (!details?.includes(currentPath?.code || '') && currentPath?.code) {
              navigate('/oss/403');
            }
          } else {
            setPermissions([]);
            if (res && res?.status !== 401) {
              navigate('/oss/403');
            }
          }
        });
      }

      setMainStore(currentUser || {});
      forceUpdate({});
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!USEID) {
    return <Spin style={{ position: 'absolute', top: '50vh', left: '50vw' }} />;
  }

  return (
    <Routes>
      <Route path="oss-status" element={<Main />}>
        <Route path="list" element={<StatusList />} />
        <Route path="/oss-status" element={<Navigate replace to="/oss-status/list" />} />
      </Route>
      <Route path="oss-enterprise" element={<Main />}>
        <Route path="list" element={<EnterpriseList />} />
        <Route path="/oss-enterprise" element={<Navigate replace to="/oss-enterprise/list" />} />
      </Route>
      <Route path="rule-config" element={<Main />}>
        <Route path="rules" element={<Rules />} />
        <Route path="objects" element={<RuleObject />} />
        <Route path="props" element={<Props />} />
      </Route>
      <Route path="source-material" element={<Main />}>
        <Route path="list" element={<SourceMaterial />} />
      </Route>
      <Route path="/oss-status/details/:taskId" element={<StatusDetails />} />
      <Route path="/oss/403" element={<NoPermisson />}></Route>
      <Route path="/" element={<Navigate replace to="/oss-status/list" />} />
      <Route path="compony-set" element={<Main />}>
        <Route path="index" element={<ComponySet />} />
      </Route>
      <Route path="users-set" element={<Main />}>
        <Route path="list" element={<UsersSet />} />
      </Route>
      <Route path="flex-group" element={<Main />}>
        <Route path="list" element={<FlexGroup />} />
      </Route>
      <Route path="oss-mtbf" element={<Main />}>
        <Route path="list" element={<MbtfList />} />
      </Route>
      <Route path="app-binding" element={<Main />}>
        <Route path="list" element={<AppBinding />} />
      </Route>
      <Route path="app-manage" element={<Main />}>
        <Route path="list" element={<AppManage />} />
      </Route>
      <Route path="sign-payment" element={<Main />}>
        <Route path="list" element={<SignAndPayment />} />
      </Route>
      <Route path="sla" element={<Main />}>
        <Route path="list" element={<SlaList />} />
      </Route>
      <Route path="render-management" element={<Main />}>
        <Route path="/render-management" element={<RenderManagement />} />
      </Route>
      <Route path="/render-management/details/:taskId" element={<RenderDetails />} />
    </Routes>
  );
};

export default App;
